/** @jsx jsx */
import React, { useContext } from 'react'
import { Box, Flex, jsx } from 'theme-ui'
import styled from '@emotion/styled'

import { css, Global } from '@emotion/core'

import { ShopifyContext } from '../Layout'

import CartPage from './CartPage'
import { mobile } from '../shared'
import { pinBody } from '../shared/Nav/Nav'
import { graphql } from 'gatsby'

const CartDrawerWrapper = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  max-width: 400px;
  transform: ${p => (p.isOpen ? 'translateX(0%)' : 'translateX(100%)')};
  width: ${p => (p.isOpen ? '100%' : '0px')};
  overflow: ${p => (p.isOpen ? 'auto' : 'hidden')};
  background-color: white;
  transition: all 300ms;
  z-index: ${p => p.theme.zIndex[5] + 1};
  justify-content: stretch;
  align-items: stretch;
  ${p =>
    mobile(css`
      max-width: 550px;
      padding-bottom: 10px;
    `)}
`

export const Overlay = styled.div`
  &::after {
    content: '';
    background: black;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${p => p.theme.zIndex[5]};
    transition: 0.2s all;
    opacity: ${props => (props.isOpen ? '.8' : '0')};
    visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  }
`

const CartDrawer = ({ ...rest }) => {
  const { cartOpen, toggleCart } = useContext(ShopifyContext)
  return (
    <>
      {cartOpen && <Global styles={pinBody} />}
      <Overlay onClick={toggleCart} isOpen={cartOpen} />
      <CartDrawerWrapper isOpen={cartOpen} {...rest}>
        <Box sx={{ width: '100%' }}>
          {cartOpen && (
            <CartPage {...rest} cartOpen={cartOpen} toggleCart={toggleCart} />
          )}
        </Box>
      </CartDrawerWrapper>
    </>
  )
}

export const GET_CART = graphql`
  fragment ContentfulCartDetails on ContentfulCart {
    ctaImage {
      fluid(maxWidth: 300) {
        ...GatsbyContentfulFluid_withWebp_noBase64
      }
    }
    defaultCart
    cartName
    ctaSubTitle
    ctaTitle
    ctaDescription
    cartSubCta
  }
`

export default CartDrawer
